import { method } from "lodash";
import { apiError } from "../../utils/GTMDataLayer";
import { logger } from "@goldenbird1/ui-logger-library";
import Router from "next/router";

export const getDropshipProducts =
  (body, buyerId, callback = "") =>
  async (dispatch) => {
    let url = `${process.env.NEXT_PUBLIC_REACT_APP_DROPSHIP_STORE_URL}/mystore/v1/dropShip`;
    fetch(
      url,
      {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          // Authorization: "Bearer " + token,
        },
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw res;
        }
      })
      .then((res) => {
        if (callback) {
          callback(res);
        }
      })
      .catch((err) => {
        logger("error", "Error from getDropshipProducts api:" +url+ ' : ' +err.statusText+ ': for buyerId:' + buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("dropshipProductApi", err.statusText, "GET", "checkout");
        console.log(err);
        if (callback) {
          callback({ error: "there is an error" });
        }
        if(err.status === 401){
          Router.push('/signin');
        } 
      });
  };

export const sendQuantity =
  (data, buyerId, callback = "") =>
  async (dispatch) => {
    let url = `${process.env.NEXT_PUBLIC_REACT_APP_DROPSHIP_STORE_URL}/mystore/v1/inventory/block/email`;
    fetch(
      url,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          // Authorization: "Bearer " + token,
        },
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "dropshipInventoryBlockApi",
            res.statusText || "Error while blocking inventory for mystore",
            "POST"
          );
          throw res;
        }
      })
      .then((res) => {
        if (callback) {
          callback(res);
        }
      })
      .catch((err) => {
        logger("error", "Error while blocking inventory for mystore,sendQuantity api:" +url+ ' : ' +err.statusText+ ': for buyerId:' + buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
        apiError("dropshipInventoryBlockApi", err.statusText, "POST");
        console.log(err);
        if(err.status === 401){
          Router.push('/signin');
        } 
      });
  };
